import { getToyModelHref } from '@helpers/helpers'
import { getModelPath } from '@services/s3/helpers'
import { model3d, type PublicationType, RarityDatabaseID } from '@specs/specs'
import { rarity } from '@prisma/client'
import { getKeys } from '@specs/helpers'
import { LinksEnum } from '@specs/navigation'

export type modelExtensionTypes = 'usdz' | 'glb'

type valueType = { id: number; from: number; to: number }
type rarityValuesType = Record<PublicationType, Array<valueType>>

export const getSanitizedCode = (code?: string) => (code ? (encodeURIComponent(code).endsWith('%2C') ? encodeURIComponent(code).slice(0, -3) : code) : undefined)

const rarityValues: rarityValuesType = {
    DIGITAL: [
        { id: 1, from: -1, to: -1 },
        { id: 8, from: 0, to: 1 },
        { id: 7, from: 2, to: 88 },
        { id: 6, from: 89, to: 888 },
        { id: 5, from: 889, to: 8888 },
        { id: 4, from: 8889, to: 38888 },
        { id: 3, from: 38889, to: 88888 },
        { id: 2, from: 88889, to: 999999 },
    ],
    DROP: [
        { id: 1, from: -1, to: -1 },
        { id: 8, from: 0, to: 1 },
        { id: 7, from: 2, to: 88 },
        { id: 6, from: 89, to: 888 },
        { id: 5, from: 889, to: 8888 },
        { id: 4, from: 8889, to: 38888 },
        { id: 3, from: 38889, to: 88888 },
        { id: 2, from: 88889, to: 999999 },
    ],
    TWIN: [
        { id: 1, from: -1, to: -1 },
        { id: 8, from: 0, to: 1 },
        { id: 7, from: 2, to: 10 },
        { id: 6, from: 11, to: 50 },
        { id: 5, from: 51, to: 300 },
        { id: 4, from: 301, to: 800 },
        { id: 3, from: 801, to: 2000 },
        { id: 2, from: 2001, to: 999999 },
    ],
}

//  TODO 1490 старая функция, оставил для обратной совместимости, надо выпилить и заменить на getRarityByType.
export const getRarityId = (toysCount: number) => {
    for (const r of rarityValues['DIGITAL']) {
        if (toysCount >= r.from && toysCount <= r.to) {
            return r.id
        }
    }
    return 2
}

export const getRarityByType = (toysCount: number, type: PublicationType) => {
    for (const r of rarityValues[type]) {
        if (toysCount >= r.from && toysCount <= r.to) {
            return r.id
        }
    }
    return 2
}

/**
 * Helper, чтобы не ходить лишний раз в бд.
 * Находит в RarityDatabaseID рарность по id.
 * */
export const getRarityById = (id: rarity['id']) => getKeys(RarityDatabaseID).find((key) => id == RarityDatabaseID[key])

/**
 * Для миграции моделей, все новые созданные игрушки идут в R2
 */
type mediaProvidersType = 'r2' | undefined
export const r2MediaProvider: mediaProvidersType = 'r2'

export const generateToyModelPath = (model?: model3d | null) => {
    if (!model)
        return {
            usdz: '',
            glb: '',
        }

    if (model.provider === r2MediaProvider) {
        if (!model.hash)
            return {
                usdz: '',
                glb: '',
            }
        return {
            usdz: getModelPath(model.hash, 'usdz'),
            glb: getModelPath(model.hash, 'glb'),
        }
    }

    return {
        usdz: getToyModelHref(model.archiveName, model.hash, 'usdz'),
        glb: getToyModelHref(model.archiveName, model.hash, 'glb'),
    }
}

export const get8thWallLink = (model: Pick<model3d, 'archiveName' | 'hash' | 'provider'>) =>
    `${LinksEnum.EIGHTH_WALL}?archiveName=${model?.archiveName}${!!model?.hash ? `&hash=${model?.hash}` : ''}${!!model?.provider ? `&provider=${model?.provider}` : ''}`
